import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useUnitCategories, useDeleteUnitCategories } from '../../../hooks/admin/useUnitCategories';
import UnitCategoryTable from '../../../components/admin/UnitCategoryTable';
import DeleteDialog from '../../../components/admin/DeleteDialog';

export default function UnitCategoryList() {
  const { data: categories, isLoading } = useUnitCategories();
  const deleteCategories = useDeleteUnitCategories();
  const [selectedIds, setSelectedIds] = useState<number[]>([]);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);

  // Debug logging
  console.log('UnitCategoryList - categories:', categories);
  if (categories && categories.length > 0) {
    console.log('First category:', categories[0]);
    console.log('First category keys:', Object.keys(categories[0]));
  }

  const handleDelete = async () => {
    try {
      await deleteCategories.mutateAsync(selectedIds);
      setSelectedIds([]);
      setShowDeleteDialog(false);
    } catch (error) {
      console.error('Failed to delete unit categories:', error);
    }
  };

  if (isLoading) return <div>Loading unit categories...</div>;
  if (!categories) return null;

  return (
    <div>
      <h1 className="text-3xl font-bold mb-6">Unit Categories</h1>

      <div className="bg-white rounded-lg shadow overflow-hidden">
        <UnitCategoryTable
          categories={categories}
          selectedIds={selectedIds}
          onSelectionChange={setSelectedIds}
        />
      </div>

      <div className="mt-6 flex gap-4">
        <Link
          to="/admin/units/new"
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
        >
          Create New Unit Category
        </Link>

        {selectedIds.length > 0 && (
          <button
            onClick={() => setShowDeleteDialog(true)}
            className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
          >
            Delete Selected ({selectedIds.length})
          </button>
        )}
      </div>

      <DeleteDialog
        open={showDeleteDialog}
        onClose={() => setShowDeleteDialog(false)}
        onConfirm={handleDelete}
        title="Delete Unit Categories"
        message={`Are you sure you want to delete ${selectedIds.length} unit categor${selectedIds.length === 1 ? 'y' : 'ies'}? This will remove all associated formulas.`}
        isLoading={deleteCategories.isPending}
      />
    </div>
  );
}
